import 'quasar/src/css/index.sass';
import '@/css/fontawesome-v5-pro.css'
import '@/css/styles-quasar.scss';
import iconSet from 'quasar/icon-set/fontawesome-v5-pro';

import {
  Loading,
  Notify,
  Quasar
} from 'quasar'

Loading.setDefaults({
  spinnerSize: 60
})

Notify.setDefaults({
  badgePosition: 'top-right',
  color: 'white',
  html: true,
  position: 'top',
  textColor: 'body-other',
  timeout: 5000
})

Notify.registerType('error', {
  color: 'notify-yellow',
  icon: 'fas fa-exclamation-triangle',
  iconColor: 'warning',
  timeout: 0
})
Notify.registerType('message', {
  actions: [
    {
      color: 'primary-color',
      icon: 'far fa-times'
    }
  ],
  color: 'notify-blue',
  icon: 'fas fa-check-circle',
  iconColor: 'notify-blue',
  timeout: 5000,
})
Notify.registerType('warning', {
  color: 'notify-yellow',
  icon: 'fas fa-exclamation-triangle',
  iconColor: 'warning',
  timeout: 5000,
})

export const registerQuasar = (app) => app.use(Quasar, {
  plugins: {
    Loading,
    Notify
  },
  iconSet,
  config: {}
})
